// This is generated.  Alter it in blockGroups/formElements/types/Image.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      foreignNamespace,
      foreignRelation,
      propertyName,
      required,
    } = hNode;

    // This block references a foreign namespace/relation.
    // The foreign relation declaration is handled by the schema metadata (x-foreignNamespace, x-foreignRelation).
    let subDataDictionary = {};

    const { isOptional: optional, schemaOptions } =
      moduleRegistration.resolveFieldFlags(required, context);

    // Helper to wrap a schema as optional if needed
    const maybeOptional = (schema) =>
      optional ? Type.Optional(schema) : schema;

    // Build the object schema with _id property for the image reference
    const imageObjectSchema = maybeOptional(
      Type.Object(
        {
          _id: Type.String({
            title: 'Unique ID',
            'x-propertyName': '_id',
            'x-dataType': 'string',
          }),
        },
        {
          title: title,
          'x-id': id,
          'x-dataType': 'object',
          'x-propertyName': propertyName,
          'x-format': 'image',
          ...schemaOptions,
          'x-foreignNamespace': foreignNamespace,
          'x-foreignRelation': foreignRelation,
          additionalProperties: true,
        },
      ),
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: imageObjectSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('formElements', 'Image', module.exports);
